"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _AffiliateActiveTagComponent = _interopRequireDefault(require("./AffiliateActiveTagComponent"));
var _affiliateActions = require("../../redux/actions/affiliateActions");
var _snackbarActions = require("../../redux/actions/snackbarActions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var mapStateToProps = function mapStateToProps(state, ownProps) {
  var route = ownProps.route;
  return {
    route: route,
    affiliate: state.affiliate
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    openAffiliateModal: function openAffiliateModal() {
      return dispatch((0, _affiliateActions.openAffiliateModal)());
    },
    showSnack: function showSnack(text) {
      return dispatch((0, _snackbarActions.showSnack)({
        id: 'affiliateCopyTage',
        text: text,
        type: 'success'
      }));
    }
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_AffiliateActiveTagComponent["default"]);